import api from 'api/apiInstance';

import type { VulnerabilityAiDraftResponse } from '../types';

// Reads the pending (unconfirmed) AI-suggested draft for this case, consumed
// ONLY by the AI-scan panel. Kept off `last`/`index` on purpose: those feed
// the badge/form/history, which must show only counted assessments (L1c).
//
// Separately dark: 404 = the AI sub-flag (`enable_ai_vulnerability`) is off →
// the panel renders no scan UI at all (fail-closed). 200 with `data: null`
// means the flag is on but nothing is pending → offer "Run scan".
export function clientCaseVulnerabilityAssessmentsDraftApi(path: string) {
  return {
    path,
    GET: () =>
      api.get<VulnerabilityAiDraftResponse>(path, {
        // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
        skipRedirect: true,
      }),
  };
}
